import { useEffect, useState } from "react";

/**
 * A value that lags behind the one you pass, settling once typing stops.
 *
 * Search-as-you-type against a server needs this or every keystroke is a
 * request: "coca cola" is nine, eight of which are already stale by the time
 * they land. On a township 3G connection that is the difference between a search
 * that feels instant and one that stutters.
 *
 * Deliberately not applied to barcode scanning. A scanner types its payload and
 * a newline in a few milliseconds, and the handler for that reads the whole line
 * rather than debouncing characters.
 */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
